import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { getChargeAmount } from '../reducer/chargeAmount/selectors';
import CustomCashOption from '../components/CustomCashOption';
import limitValue from '../../../common/hoc/limitValue';

const CustomCashOptionContainer = compose(
  withState('active', 'setActive', false),
  withState('value', 'setValue', 0),
  connect((state, ownProps) => {
    const chargeAmount = getChargeAmount(state);
    return {
      chargeAmount,
      disabled: chargeAmount > ownProps.value,
    };
  }),
  withHandlers({
    setActive: props => () => props.setActive(true),
    onChange: props => tipAmount => props.setValue(tipAmount),
    onSubmit: props => (e) => {
      e.preventDefault();
      props.onSubmit(props.value);
    },
  }),
  limitValue(),
);

export default CustomCashOptionContainer(CustomCashOption);
